import environment from "environment";
import type { Filters, Sorting } from "@fas/ui-framework";
import qs from "qs";
import { requestService } from "../request";
import type { Redirect } from "../../reducers/redirectList";
import type { RedirectInfo } from "../../containers/RedirectInfo/types/RedirectInfo.type";

export type Payload = {
  page: number,
  pageSize: number,
  filters: Filters,
  sorting: Sorting,
};

export const getRedirect = (id: string): Promise<Redirect> => requestService
  .get(environment.endpoints.get.redirect.replace("{id}", id));

export const createRedirect = (data: RedirectInfo): Promise<any> => requestService
  .post(environment.endpoints.post.redirect, data);

export const updateRedirect = (redirectId: string, data: RedirectInfo): Promise<any> => requestService
  .put(environment.endpoints.put.redirect.replace("{id}", redirectId), { data: { ...data } });

export const getRedirectList = (options: Payload): Promise<Array<Redirect>> => requestService
  .get(environment.endpoints.get.redirectList, {
    params: { ...options },
    paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: "brackets", encode: false }),
  });

export const deleteRedirect = (redirectId: string): Promise<any> => requestService
  .delete(environment.endpoints.delete.redirect, {
    data: {
      data: redirectId,
    },
  });
